/** @format */
import { _$ } from '@king-design/react'

import React, { useState, createContext, useEffect } from 'react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { useParams } from 'react-router'
import { get } from 'lodash'
import EditScene from './EditScene'
import ViewScene from './ViewScene'
import { useAsync, useAsyncFn } from 'react-use'
import { getScene, getSceneList } from 'src/api/ApiEventOpsScene'
import { SceneRecordDetailProps, SceneRecordItemProp } from '../container'

interface IContextType {
  editable?: boolean
  setEditable?: (editable: boolean) => void
  sign?: string
  sceneInfo?: SceneRecordDetailProps
  subSceneList?: SceneRecordItemProp[]
  fetchSubSceneList?: () => void
}
export const CountContext = createContext<IContextType>({})
const SceneDetail: React.FC<{ className?: string }> = ({ className }) => {
  const params = useParams()
  const sign = get(params, 'sign')
  const [editable, setEditable] = useState(sign ? false : true) // 编辑状态

  // 场景详情
  const { value: sceneInfo } = useAsync(async () => {
    if (sign) {
      const result = await getScene(sign, editable)
      return result
    } else {
      return {}
    }
  }, [sign, editable])

  // 获取子场景列表
  const [{ value: subSceneList }, fetchSubSceneList] = useAsyncFn(async () => {
    const result = await getSceneList({
      Offset: 0,
      Limit: 9999,
      Status: 2
    })
    return result?.Info || []
  }, [])

  useEffect(() => {
    fetchSubSceneList && fetchSubSceneList()
  }, [fetchSubSceneList])

  return (
    <div id="scene_detail" className={className}>
      <MonitorCrumb
        breadArr={[
          { title: _$('自动化运维') },
          { title: _$('自动化场景'), route: '/monitor/eventops/scene' },
          { title: sign ? _$('详细信息') : _$('新建场景') }
        ]}
      />
      <CountContext.Provider
        value={{ editable, setEditable, sign, sceneInfo, subSceneList, fetchSubSceneList }}
      >
        {editable ? <EditScene /> : <ViewScene />}
      </CountContext.Provider>
    </div>
  )
}

export default styled(SceneDetail)`
  padding: 0 16px;
`
